import { NgModule } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GenesysCloudNotificationEffects } from './effects/notification.effects';
import { initializeModule } from './actions/notification.actions';
import { BcConfigService } from 'common/config/provider';
import { genesysCloudNotificationsReducer } from './reducers/notification.reducers';
import { featureKey } from './reducers/feature-key';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudNotificationsReducer),
    EffectsModule.forFeature([
      GenesysCloudNotificationEffects
    ])
  ]
})
export class GenesysCloudNotificationsModule {
  constructor(readonly store: Store, readonly configService: BcConfigService) {
    if (configService.isGenesysConversationEnabled()) {
      store.dispatch(initializeModule());
    }
  }
}
